import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";

import LiveClasses from "../pages/liveClass/LiveClasses";
import LoginPage from "../pages/auth/LoginPage";
import RecordedClasses from "../pages/pastSession/RecordedClasses";
import DoubtSession from "../pages/askDoubt/DoubtSession";
import Report from "../pages/viewReport/Report";
import Calendar from "../pages/calendar/Calendar";
import HomePage from "../pages/home/HomePage";
import RegisterUser from "../pages/auth/RegisterUser";
import Subscription from "../pages/subscription/SubscriptionPage"
import ReconfirmationPage from "../pages/subscription/ReconfirmationPage"
import PlayerPage from "../pages/player/PlayerPage";
import LandingPage from "../components/Home/LandingPage";
import ForgetPasswordPage from "../pages/auth/ForgetPasswordPage";
import LoginWithOtp from "../pages/auth/LoginWithOtp";
import TermsOfUse from "../pages/terms_and_policy/TermsandCondition";
import Policy from "../pages/terms_and_policy/policy";
import HowToUse from "../pages/terms_and_policy/HowToUse";
import DemoSession from "../pages/terms_and_policy/Demosession"




const AppRoutes = () => {
  const stored = localStorage.getItem("user")
  const user = stored? JSON.parse(stored) : [];

  return (
    <Routes>

      {/*  Login (NO layout) */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<RegisterUser />} />
      <Route path="/subscription" element={<Subscription />} />
      
      <Route path="/home-page" element={<HomePage />} />
      <Route path="/reconfirmation" element={<ReconfirmationPage />} />
      <Route path="/forget-password" element={<ForgetPasswordPage />} />
      <Route path="/login-with-otp" element={<LoginWithOtp />} />

      <Route path="/" element={<LandingPage />} />
      <Route path="/terms-condition" element={<TermsOfUse/>}/>
      <Route path="/policy" element={<Policy/>}/>
      <Route path="/howtouse" element={<HowToUse/>}/>
      <Route path="/demo-session" element={<DemoSession/>}/>

      {/* <Route path="/test" element={<StudentHome />} /> */}

      {/*  Layout Wrapper */}
      <Route element={<MainLayout />}>

        {/* Default */}
        <Route
          path="/"
          element={
            user
              ? <Navigate to="/live-classes" replace />
              : <Navigate to="/login" replace />
          }
        />

        {/*  IMPORTANT: Put pages HERE */}
        <Route path="/live-classes" element={<LiveClasses />} />
        <Route path="/recorded-session" element={<RecordedClasses />} />
        <Route path="/doubt-session" element={<DoubtSession />} />
        <Route path="/report" element={<Report />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/player" element={<PlayerPage />} />


      </Route>


    </Routes>
  );
};

export default AppRoutes;